"use client";

import Link from "next/link";
import { useSelectedLayoutSegments } from "next/navigation";

const CategoryLink = ({ item, currentCategory }: any) => {
  const slug = item?.title?.toLowerCase().replaceAll(" ", "-");

  return (
    <li className="py-0.5" key={item?.sys?.id}>
      <Link
        className={`${
          currentCategory && slug.includes(currentCategory) ? "underline" : ""
        } hover:underline`}
        href={`/magasin/${slug}`}
      >
        <p>{item?.title}</p>
      </Link>
    </li>
  );
};

const ArticleFilter = ({ categories }: any) => {
  const segments = useSelectedLayoutSegments();
  const currentCategory = segments.length === 2 ? segments[0] : undefined;

  return (
    <nav className="col-span-3 hidden px-3 lg:block xl:col-span-2">
      <ul>
        <li className="py-0.5">
          <Link href="/magasin">
            <p className="font-normal uppercase hover:underline">Magasin</p>
          </Link>
        </li>
        {categories &&
          categories
            .filter(Boolean)
            .map((item: any) => (
              <CategoryLink
                key={item?.sys?.id}
                currentCategory={currentCategory}
                item={item}
              />
            ))}
      </ul>
    </nav>
  );
};
export default ArticleFilter;
